import React, { Component } from 'react';
import view from '../Enums';
import * as IMAGES from '../Images';
import {
  contact,
  ready_to_get_started,
  ready_to_get_started_mobile,
  FlexColumn,
  FlexRow,
  readyImg,
  readyImgMobile,
  ReadyToGetStarted_header,
  ReadyToGetStarted_header_mobile,
  ListingYourBusines,
  ListingYourBusines_mobile
} from '../partnerStyles';
import ImageTextComponent from './ImageTextComponent';
import { bindActionCreators } from 'redux';
import * as GlobalActions from '../reducers/actions';
import { connect } from 'react-redux';
import { hmsSelfOnboardingEnabled } from '../config/countryConfig';

class ReadyToGetStarted extends Component {
  render() {
    let divStyle,
      componentStyle,
      imgStyle,
      headerStyle,
      headerGetStarted,
      contentStyle,
      listingStyle,
      imgWidth,
      textStyle;
    if (
      this.props.viewSize === 'Desktop' ||
      this.props.viewMode == view.DESKTOP
    ) {
      divStyle = ready_to_get_started;
      componentStyle = FlexRow;
      imgStyle = readyImg;
      headerGetStarted = ReadyToGetStarted_header;
      listingStyle = ListingYourBusines;
      imgWidth = '100%';
      textStyle = {
        marginBottom: '30px',
        width: '43%',
        fontFamily: 'InterphaseBold'
      };
    } else {
      divStyle = ready_to_get_started_mobile;
      componentStyle = FlexColumn;
      imgStyle = readyImgMobile;
      headerGetStarted = ReadyToGetStarted_header_mobile;
      listingStyle = ListingYourBusines_mobile;
      imgWidth = '100%';
    }
    return (
      <div style={divStyle} ref={this.props.setReadyRef}>
        {this.props.globalData && this.props.globalData.universal_translations && (
          <ImageTextComponent
            btnFunc={this.props.handleScrollToForm}
            viewMode={this.props.viewMode}
            imgInheritedStyle={{ maxHeight: '320px' }}
            src={IMAGES.READY_TO_GET_STARTED}
            width={imgWidth}
            locale={this.props.globalData.locale}
            componentStyle={componentStyle}
            header={
              this.props.globalData.universal_translations.ready_to_get_started
            }
            content={
              this.props.globalData.universal_translations
                .ready_to_get_started_content
            }
            textStyle={textStyle}
            imgStyle={imgStyle}
            headerStyle={headerGetStarted}
            contentStyle={listingStyle}
            // contactInfo={this.props.globalData.universal_translations.call}
            join={hmsSelfOnboardingEnabled() ? this.props.globalData.universal_translations.get_started : this.props.globalData.universal_translations.join_us}
            viewSize={this.props.viewSize}
            joinButtonStyle={{
              width: '177px',
              height: '48px',
              borderRadius: '2px',
              border: '0',
              boxShadow: '0 4px 8px 0 rgba(26, 182, 79, 0.2)',
              backgroundColor: '#1ab64f',
              fontSize: '16px',
              fontWeight: 'bold',
              fontStretch: 'normal',
              fontStyle: 'normal',
              lineHeight: '1.5',
              letterSpacing: 'normal',
              color: '#ffffff',
              marginTop: '16px'
            }}
            redirectToHms={this.props.redirectToHms}
          />
        )}
      </div>
    );
  }
}
const mapDispatchToProps = dispatch => {
  return {
    globalActions: bindActionCreators(GlobalActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    globalData: state.globalReducer
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReadyToGetStarted);
